__turbopack_context__.v({
  "catalog": "r-4-ha_catalog",
  "container": "r-4-ha_container",
  "content": "r-4-ha_content",
  "description": "r-4-ha_description",
  "descriptionHeading": "r-4-ha_descriptionHeading",
  "export": "r-4-ha_export",
  "image": "r-4-ha_image",
  "overview": "r-4-ha_overview",
  "overviewActions": "r-4-ha_overviewActions",
  "overviewInner": "r-4-ha_overviewInner",
  "overviewSealed": "r-4-ha_overviewSealed",
  "subheader": "r-4-ha_subheader",
});
